(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .controller('InvoiceDetailController', InvoiceDetailController);

    InvoiceDetailController.$inject = ['$scope', '$rootScope', 'InvoiceDialogProvider', '$uibModal', 'previousState', 'entity',
        'InvoiceDTO', 'InvoiceCustomService', 'Keyword', 'InvoicePayment', 'ActivityHistory', 'Comment', 'Shipment', 'Lot', 'PDFExportService',
        'LotCustomService', 'CommentCustomService', 'AttachmentCustomService', 'InvoicePaymentCustomService', 'ToastrService', 'category',
        'MiscService','ControllerCustomService'];

    function InvoiceDetailController($scope, $rootScope, InvoiceDialogProvider, $uibModal, previousState, entity,
                                     InvoiceDTO, InvoiceCustomService, Keyword, InvoicePayment, ActivityHistory, Comment, Shipment, Lot, PDFExportService,
                                     LotCustomService, CommentCustomService, AttachmentCustomService, InvoicePaymentCustomService, ToastrService, category,
                                     MiscService, ControllerCustomService ) {
        var vm = this;

        vm.invoice = entity;
        if (vm.invoice.invWtUnits === undefined || vm.invoice.invWtUnits === null) {
            vm.invoice.invWtUnits = vm.invoice.invoiceContractUnitType;
        }

        vm.invoice.pricePrecision = vm.invoice.invoicePricePrecision;
        vm.invoice.weightPrecision = vm.invoice.invoiceWeightPrecision;
        vm.invoice.valuePrecision = vm.invoice.invoiceValuePrecision;

        vm.category = category;
        vm.updateInvoice = updateInvoice;
        vm.refresh = refresh;
        vm.downloadPdf = downloadPdf;
        vm.downloadSalePdf = downloadSalePdf;
        vm.downloadDebitNotePdf = downloadDebitNotePdf;
        vm.downloadNContractPdf = downloadNContractPdf;
        vm.viewLotDetails = viewLotDetails;
        vm.switchUnitWeightType = switchUnitWeightType;
        vm.returnCorrectWeightPriceOrValue = returnCorrectWeightPriceOrValue;
        vm.calculateTotalQty = calculateTotalQty;
        vm.calculateTotalMt = calculateTotalMt;
        vm.calculateTotalWeight = calculateTotalWeight;
        vm.calculateTotalWeightLb = calculateTotalWeightLb;
        vm.calculateTotalWeightLbDetails = calculateTotalWeightLbDetails;
        vm.calculateAvgPrice = calculateAvgPrice;
        vm.calculateTotalOverrideValue = calculateTotalOverrideValue;
        vm.calculateAvgNContractPrice = calculateAvgNContractPrice;
        vm.calculateTotalNContractValue = calculateTotalNContractValue;
        vm.showNContract = showNContract;
        vm.setPrecision = setPrecision;
        vm.calculateTotalOverrideValueDisplay = calculateTotalOverrideValueDisplay;
        vm.calculateTotalWeightDisplay = calculateTotalWeightDisplay;
        vm.resolvePrePayments = resolvePrePayments;
        vm.returnControllerValue = returnControllerValue;
        vm.editController = editController;
        vm.nl2br = MiscService.nl2br;

        vm.pricePrecision = 1;
        vm.weightPrecision = 2;
        vm.valuePrecision = 3;

        vm.previousState = previousState.name;
        vm.wtUnits = ['KG', 'LB', 'MT'];
        vm.invoiceId = vm.invoice.id;
        vm.shipmentId = vm.invoice.invoiceShipmentId;
        vm.contractId = vm.invoice.invoiceContractId;
        vm.contractType = vm.invoice.invoiceContractCategory;
        vm.contractSubType = vm.invoice.invoiceContractSubCategory;
        vm.showBaleApprox = false;
        vm.selectedUnitWeightType = vm.invoice.invoiceContractUnitType;
        vm.invoicePrices = [];
        vm.prePayments = [];
        checkShipmentQtyType();

        vm.controllerList = [];
        vm.lotList = [];
        vm.commentList = [];
        vm.attachmentList = [];
        vm.paymentList = [];
        vm.showComment = false;
        vm.showAttachment = false;
        vm.showPayments = false;
        vm.showLotLandedWts = false;
        vm.showDNDetails = false;
        vm.contractWtUnitType = "";
        vm.contractPriceModel = "";
        vm.lotTotal = {
            bales: 0,
            purchLandedGrossKgs: 0,
            purchLandedNetKgs: 0,
            purchLandedTareKgs: 0,
            purchLandedGrossLbs: 0,
            purchLandedNetLbs: 0,
            purchLandedTareLbs: 0,
            purchLandedGrossMTs: 0,
            purchLandedNetMTs: 0,
            purchLandedTareMTs: 0,
            purchValue: 0,
            saleLandedGrossKgs: 0,
            saleLandedNetKgs: 0,
            saleLandedTareKgs: 0,
            saleLandedGrossLbs: 0,
            saleLandedNetLbs: 0,
            saleLandedTareLbs: 0,
            saleLandedGrossMTs: 0,
            saleLandedNetMTs: 0,
            saleLandedTareMTs: 0,
            saleValue: 0
        };
        checkDNDetails();
        resolveLazyStuff();
        // resolveInvoicePrices();

        function setPrecision(originalValue, scale) {
            return parseFloat(originalValue).toFixed(scale);
        }

        var unsubscribe = $rootScope.$on('ccsTrApp:invoiceUpdate', function (event, result) {
            vm.invoice = result;
        });
        $scope.$on('$destroy', unsubscribe);

        function refresh() {
            refetchInvoice(vm.invoiceId);
        }

        function refetchInvoice(id) {
            InvoiceDTO.get({id: id}).$promise.then(function (result) {
                vm.invoice = result;
                vm.invoiceId = vm.invoice.id;
                vm.shipmentId = vm.invoice.invoiceShipmentId;
                vm.contractId = vm.invoice.invoiceContractId;
                vm.contractType = vm.invoice.invoiceContractCategory;
                vm.contractSubType = vm.invoice.invoiceContractSubCategory;
                vm.selectedUnitWeightType = vm.invoice.invoiceContractUnitType;
                checkDNDetails();
                checkShipmentQtyType();
                resolveLazyStuff();
            }, function (error) {
                ToastrService.error("Cannot refresh invoice data");
            });
        }

        function resolveInvoicePrices() {
            InvoiceCustomService.getMinifiedInvoicePricesByInvoice(vm.invoice.id, vm.invoice.invoiceType).then(function (result) {
                vm.invoicePrices = result.data;
                InvoiceDialogProvider.initInvoicePricesOnDetails(vm);
            }, function (error) {
                vm.invoicePrices = [];
                ToastrService.error("Cannot load invoice's price with invoice id: " + vm.invoice.id);
            });
        }

        function resolvePrePayments() {
            InvoiceCustomService.returnInvoicePrePayments(vm.invoice.id).then(function (data) {
                vm.prePayments = data.data;
            }, function (error) {
                vm.prePayments = [];
                console.log(error.status, error.statusText);
            });
        }

        function resolveLazyStuff() {
            resolveLots();
            resolveControllers();
            resolveInvoicePayments();
            resolvePrePayments();
            determineContractWtUnitType();
            determineContractPriceModel();
            resolveInvoicePrices();
            resolveComments();
        }

        function resolveLots() {
            vm.lotList.length = 0;
            LotCustomService.getMinifiedLotsByShipmentContract(vm.shipmentId, vm.contractId, vm.category.type).then(function (data) {
                vm.lotList = data.data;
                if (vm.lotList.length > 0) {
                    buildLotTotals();
                    // ToastrService.success("Successfully fetched Lots", "Success!");
                }
            }, function (error) {
                if (error.status !== "404") {
                    ToastrService.error("Could not fetch Lots for Shipment with Id: " + vm.shipmentId);
                }
            });
        }

        function resolveControllers() {
            vm.controllerList = [];
            ControllerCustomService.getControllersByInvoice(vm.invoiceId).then(function(data) {
                vm.controllerList = data.data;
                if(vm.controllerList.length > 0) {
                    // ToastrService.success("Successfully fetched Controller(s)","Success!");
                    computeControllerValues();
                }
            }, function(error) {
                if(error.status !== 404) {
                    ToastrService.error("Failed to fetch Controllers","Error");
                }
            });
        }

        function computeControllerValues() {
            vm.controllerTotals = {
                amountUSD: 0,
                balanceUSD: 0,
                amountEUR: 0,
                balanceEUR: 0
            };
            angular.forEach(vm.controllerList, function(value, key) {
                if(value.currency === "USD") {
                    vm.controllerTotals.amountUSD += value.amount;
                    vm.controllerTotals.balanceUSD += value.balance;
                } else {
                    vm.controllerTotals.amountEUR += value.amount;
                    vm.controllerTotals.balanceEUR += value.balance;
                }
            });
        }

        function returnControllerValue(controller, field, currency) {
            switch(field) {
                case 'amount':
                    return controller.currency === currency ? setPrecision(controller.amount, 2) : setPrecision(0,2);
                    break;
                case 'balance':
                    return controller.currency === currency ? setPrecision(controller.balance, 2) : setPrecision(0,2);
                    break;
                default:
                    return setPrecision(0, 2);
                    break;
            }
        }

        function editController(controller) {
            var modalInstance = $uibModal.open({
                templateUrl: 'app/entities/controller/controller-dialog.html',
                controller: 'ControllerDialogController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    entity: function() {
                        return controller;
                    },
                    translatePartialLoader: ['$translate','$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('controller');
                        $translatePartialLoader.addPart('currencyType');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            });
            modalInstance.result.then(function() {
                resolveControllers();
            });
        }

        function resolveInvoicePayments() {
            vm.paymentList.length = 0;
            vm.showPayments = false;
            InvoicePaymentCustomService.getMinifiedInvoicePaymentsForInvoiceDetailByInvoice(vm.invoiceId).then(function (data) {
                vm.paymentList = data.data;
                if (vm.paymentList.length > 0) {
                    vm.showPayments = true;
                    // ToastrService.success("Successfully fetched Invoice Payments", "Success!");
                }
            }, function (error) {
                if (error.status !== "404") {
                    ToastrService.error("Could not fetch Payments for Invoice with id: " + vm.invoiceId);
                }
            });
        }

        function resolveComments() {
            vm.commentList.length = 0;
            CommentCustomService.returnCommentsByInvoice( vm.invoiceId ).then( function( data ) {
                vm.commentList = data.data;
                if( vm.commentList.length > 0 ) {
                    // ToastrService.success("Successfully fetched Comments", "Success!");
                }
            }, function( error ) {
                if( error.status !== "404" ) {
                    ToastrService.error("Could not fetch Comments for Invoice with Id:  " + vm.invoiceId );
                }
            });
        }

        function buildLotTotals() {
            switch (vm.invoice.invType) {
                case 'PURCHASE':
                    vm.lotTotal = {
                        bales: 0,
                        purchLandedGrossKgs: 0,
                        purchLandedNetKgs: 0,
                        purchLandedTareKgs: 0,
                        purchLandedGrossLbs: 0,
                        purchLandedNetLbs: 0,
                        purchLandedTareLbs: 0,
                        purchLandedGrossMTs: 0,
                        purchLandedNetMTs: 0,
                        purchLandedTareMTs: 0,
                        purchValue: 0
                    };
                    angular.forEach(vm.lotList, function (value, key) {
                        vm.lotTotal.bales += parseInt(value.qtyBales);
                        vm.lotTotal.purchLandedGrossKgs = Math.round(( vm.lotTotal.purchLandedGrossKgs + value.purchLandedGrossKgs ) * 100) / 100;
                        vm.lotTotal.purchLandedNetKgs = Math.round(( vm.lotTotal.purchLandedNetKgs + value.purchLandedNetKgs ) * 100) / 100;
                        vm.lotTotal.purchLandedTareKgs = Math.round(( vm.lotTotal.purchLandedTareKgs + value.purchLandedTareKgs ) * 100) / 100;
                        vm.lotTotal.purchLandedGrossLbs = Math.round(( vm.lotTotal.purchLandedGrossLbs + value.purchLandedGrossLbs ) * 100) / 100;
                        vm.lotTotal.purchLandedNetLbs = Math.round(( vm.lotTotal.purchLandedNetLbs + value.purchLandedNetLbs ) * 100) / 100;
                        vm.lotTotal.purchLandedTareLbs = Math.round(( vm.lotTotal.purchLandedTareLbs + value.purchLandedTareLbs ) * 100) / 100;
                        vm.lotTotal.purchLandedGrossMTs = Math.round(( vm.lotTotal.purchLandedGrossMTs + value.purchLandedGrossMTs ) * 100) / 100;
                        vm.lotTotal.purchLandedNetMTs = Math.round(( vm.lotTotal.purchLandedNetMTs + value.purchLandedNetMTs ) * 100) / 100;
                        vm.lotTotal.purchLandedTareMTs = Math.round(( vm.lotTotal.purchLandedTareMTs + value.purchLandedTareMTs ) * 100) / 100;
                        vm.lotTotal.purchValue = Math.round(( vm.lotTotal.purchValue + value.purchValue ) * 100) / 100;
                    });
                    break;
                case 'SALE':
                    vm.lotTotal = {
                        bales: 0,
                        saleLandedGrossKgs: 0,
                        saleLandedNetKgs: 0,
                        saleLandedTareKgs: 0,
                        saleLandedGrossLbs: 0,
                        saleLandedNetLbs: 0,
                        saleLandedTareLbs: 0,
                        saleLandedGrossMTs: 0,
                        saleLandedNetMTs: 0,
                        saleLandedTareMTs: 0,
                        saleValue: 0
                    };
                    angular.forEach(vm.lotList, function (value, key) {
                        vm.lotTotal.bales += parseInt(value.qtyBales);
                        vm.lotTotal.saleLandedGrossKgs = Math.round(( vm.lotTotal.saleLandedGrossKgs + value.saleLandedGrossKgs ) * 100) / 100;
                        vm.lotTotal.saleLandedNetKgs = Math.round(( vm.lotTotal.saleLandedNetKgs + value.saleLandedNetKgs ) * 100) / 100;
                        vm.lotTotal.saleLandedTareKgs = Math.round(( vm.lotTotal.saleLandedTareKgs + value.saleLandedTareKgs ) * 100) / 100;
                        vm.lotTotal.saleLandedGrossLbs = Math.round(( vm.lotTotal.saleLandedGrossLbs + value.saleLandedGrossLbs ) * 100) / 100;
                        vm.lotTotal.saleLandedNetLbs = Math.round(( vm.lotTotal.saleLandedNetLbs + value.saleLandedNetLbs ) * 100) / 100;
                        vm.lotTotal.saleLandedTareLbs = Math.round(( vm.lotTotal.saleLandedTareLbs + value.saleLandedTareLbs ) * 100) / 100;
                        vm.lotTotal.saleLandedGrossMTs = Math.round(( vm.lotTotal.saleLandedGrossMTs + value.saleLandedGrossMTs ) * 100) / 100;
                        vm.lotTotal.saleLandedNetMTs = Math.round(( vm.lotTotal.saleLandedNetMTs + value.saleLandedNetMTs ) * 100) / 100;
                        vm.lotTotal.saleLandedTareMTs = Math.round(( vm.lotTotal.saleLandedTareMTs + value.saleLandedTareMTs ) * 100) / 100;
                        vm.lotTotal.saleValue = Math.round(( vm.lotTotal.saleValue + value.saleValue ) * 100) / 100;
                    });
                    break;
                default:
                    vm.lotTotal = {
                        bales: 0,
                        purchLandedGrossKgs: 0,
                        purchLandedNetKgs: 0,
                        purchLandedTareKgs: 0,
                        purchLandedGrossLbs: 0,
                        purchLandedNetLbs: 0,
                        purchLandedTareLbs: 0,
                        purchLandedGrossMTs: 0,
                        purchLandedNetMTs: 0,
                        purchLandedTareMTs: 0,
                        purchValue: 0,
                        saleLandedGrossKgs: 0,
                        saleLandedNetKgs: 0,
                        saleLandedTareKgs: 0,
                        saleLandedGrossLbs: 0,
                        saleLandedNetLbs: 0,
                        saleLandedTareLbs: 0,
                        saleLandedGrossMTs: 0,
                        saleLandedNetMTs: 0,
                        saleLandedTareMTs: 0,
                        saleValue: 0
                    };
                    angular.forEach(vm.lotList, function (value, key) {
                        vm.lotTotal.bales += parseInt(value.qtyBales);
                        vm.lotTotal.purchLandedGrossKgs = Math.round(( vm.lotTotal.purchLandedGrossKgs + value.purchLandedGrossKgs ) * 100) / 100;
                        vm.lotTotal.purchLandedNetKgs = Math.round(( vm.lotTotal.purchLandedNetKgs + value.purchLandedNetKgs ) * 100) / 100;
                        vm.lotTotal.purchLandedTareKgs = Math.round(( vm.lotTotal.purchLandedTareKgs + value.purchLandedTareKgs ) * 100) / 100;
                        vm.lotTotal.purchLandedGrossLbs = Math.round(( vm.lotTotal.purchLandedGrossLbs + value.purchLandedGrossLbs ) * 100) / 100;
                        vm.lotTotal.purchLandedNetLbs = Math.round(( vm.lotTotal.purchLandedNetLbs + value.purchLandedNetLbs ) * 100) / 100;
                        vm.lotTotal.purchLandedTareLbs = Math.round(( vm.lotTotal.purchLandedTareLbs + value.purchLandedTareLbs ) * 100) / 100;
                        vm.lotTotal.purchLandedGrossMTs = Math.round(( vm.lotTotal.purchLandedGrossMTs + value.purchLandedGrossMTs ) * 100) / 100;
                        vm.lotTotal.purchLandedNetMTs = Math.round(( vm.lotTotal.purchLandedNetMTs + value.purchLandedNetMTs ) * 100) / 100;
                        vm.lotTotal.purchLandedTareMTs = Math.round(( vm.lotTotal.purchLandedTareMTs + value.purchLandedTareMTs ) * 100) / 100;
                        vm.lotTotal.saleLandedGrossKgs = Math.round(( vm.lotTotal.saleLandedGrossKgs + value.saleLandedGrossKgs ) * 100) / 100;
                        vm.lotTotal.saleLandedNetKgs = Math.round(( vm.lotTotal.saleLandedNetKgs + value.saleLandedNetKgs ) * 100) / 100;
                        vm.lotTotal.saleLandedTareKgs = Math.round(( vm.lotTotal.saleLandedTareKgs + value.saleLandedTareKgs ) * 100) / 100;
                        vm.lotTotal.saleLandedGrossLbs = Math.round(( vm.lotTotal.saleLandedGrossLbs + value.saleLandedGrossLbs ) * 100) / 100;
                        vm.lotTotal.saleLandedNetLbs = Math.round(( vm.lotTotal.saleLandedNetLbs + value.saleLandedNetLbs ) * 100) / 100;
                        vm.lotTotal.saleLandedTareLbs = Math.round(( vm.lotTotal.saleLandedTareLbs + value.saleLandedTareLbs ) * 100) / 100;
                        vm.lotTotal.saleLandedGrossMTs = Math.round(( vm.lotTotal.saleLandedGrossMTs + value.saleLandedGrossMTs ) * 100) / 100;
                        vm.lotTotal.saleLandedNetMTs = Math.round(( vm.lotTotal.saleLandedNetMTs + value.saleLandedNetMTs ) * 100) / 100;
                        vm.lotTotal.saleLandedTareMTs = Math.round(( vm.lotTotal.saleLandedTareMTs + value.saleLandedTareMTs ) * 100) / 100;
                        vm.lotTotal.saleValue = Math.round(( vm.lotTotal.saleValue + value.saleValue ) * 100) / 100;
                    });
                    break;
            }
        }

        function updateInvoice() {
            var data = {
                heading: 'Edit ' + vm.invoice.invoiceNum,
                route: 'invoice-purchase.edit',
                id: vm.invoice.id,
                param: {id: ''}
            };
            if (vm.category.type === 'PURCHASE') {
                data.route = 'invoice-purchase.edit';
            } else if (vm.category.type === 'SALE' || vm.category.type === 'JAPAN') {
                data.route = 'invoice-sale.edit';
            }
            $rootScope.$emit('handleEmit', data);
        }

        function downloadPdf() {
            $uibModal.open({
                templateUrl: 'app/entities/invoice/dialogs/invoice-download-purchase.html',
                controller: 'DownloadPurchaseInvoicePDFController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg'
            }).result.then(function(res) {
                PDFExportService.downloadInvoicePDF(vm.invoice.id, vm.invoice.invoiceType, true, res.showVoyageDetails === 'Show', true, true, true, true, res.showPaymentTerms === 'Show', true,
                    res.showDescriptionOfGoods === 'Show', res.showPacking === 'Show', res.showIncoTerms === 'Show', res.showWeightTerm === 'Show', res.showPaymentInstruction === 'Show',
                    res.header).then(function (data, status, headers, config) {
                    var file = new Blob([data.data], {type: 'application/pdf'});
                    saveAs(file, vm.invoice.invoiceShipmentNum + '-invoice.pdf');
                }, function (error) {
                    console.log('error cannot download invoices. error is ' + error);
                });
            });
        }

        function downloadDebitNotePdf() {
            $uibModal.open({
                templateUrl: 'app/entities/invoice/dialogs/invoice-download-dnpdf.html',
                controller: 'DownloadDebitNotePDFController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg'
            }).result.then(function(res) {
                PDFExportService.downloadDebitNotePDF(vm.invoice.id, res === 'show').then(function (data) {
                    var file = new Blob([data.data], {type: 'application/pdf'});
                    saveAs(file, "DN-" + vm.invoice.invoiceNum + '.pdf');
                }, function (error) {
                    if (error !== 404) {
                        ToastrService.error("Cannot Download DN PDF: " + error.statusText, "Error");
                    }
                    console.log(error.statusText);
                });
            });
        }

        function downloadNContractPdf() {
            $uibModal.open({
                templateUrl: 'app/entities/invoice/dialogs/invoice-download-ncontractpdf.html',
                controller: 'DownloadNContractPDFController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    invoiceNum: function() {
                        return vm.invoice.invoiceNum;
                    },
                    forSale: function() {
                        return false;
                    }
                }
            }).result.then( function( res ) {
                PDFExportService.downloadNContractPDF(vm.invoice.id, res.showVessel === 'Show', res.showVoyageDetails === 'Show', res.showContract === 'Show',
                    res.showLot === 'Show', res.showLCDetails === 'Show', res.showController === 'Show', res.showPaymentTenor === 'Show', res.showLotWeights === 'Show',
                    true, true, true, true, true, res.header).then(function (data) {
                    var file = new Blob([data.data], {type: 'application/pdf'});
                    saveAs(file, "NContract-" + vm.invoice.invoiceNum + '.pdf');
                }, function (error) {
                    if (error !== 404) {
                        ToastrService.error("Cannot Download NContract PDF: " + error.statusText, "Error");
                    }
                    console.log(error.statusText);
                });
            });
        }

        function downloadSalePdf() {
            $uibModal.open({
                templateUrl: 'app/entities/invoice/dialogs/invoice-download-ncontractpdf.html',
                controller: 'DownloadNContractPDFController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    invoiceNum: function() {
                        return vm.invoice.invoiceNum
                    },
                    forSale: function() {
                        return true;
                    }
                }
            }).result.then( function( res ) {
                PDFExportService.downloadInvoicePDF(vm.invoice.id, vm.invoice.invoiceType, res.showVessel === 'Show', res.showVoyageDetails === 'Show', res.showContract === 'Show',
                    res.showLot === 'Show', res.showLCDetails === 'Show', res.showController === 'Show', res.showPaymentTenor === 'Show', res.showLotWeights === 'Show',
                    true, true, true, true, true, res.header).then(function (data, status, headers, config) {
                    var file = new Blob([data.data], {type: 'application/pdf'});
                    saveAs(file, vm.invoice.invoiceShipmentNum + '-invoice.pdf');
                }, function (error) {
                    console.log('error cannot download invoices. error is ' + error);
                });
            });
        }

        function checkShipmentQtyType() {
            vm.showBaleApprox = vm.invoice.invoiceShipmentQtyUnitType !== "BALES";
        }

        function determineContractWtUnitType() {
            vm.contractWtUnitType = vm.invoice.invoiceContractUnitType;
        }

        function determineContractPriceModel() {
            vm.contractPriceModel = vm.invoice.invoiceContractPriceType + "/" +  vm.invoice.invoiceContractUnitType;
        }

        function switchUnitWeightType(option) {
            vm.selectedUnitWeightType = option;
        }

        function viewLotDetails(lot) {
            $uibModal.open({
                templateUrl: 'app/entities/lot/modal/lot-detail-modal.html',
                controller: 'LotDetailModalController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    entity: function () {
                        return lot;
                    }
                }
            }).result.then(function (retVal) {

            });
        }

        function returnCorrectWeightPriceOrValue(lot, unit, which, invType) {
            if (checkLot(lot)) {
                switch (which) {
                    case 'gross':
                        return returnLotWeightGross(lot, unit, invType);
                    case 'net':
                        return returnLotWeightNet(lot, unit, invType);
                    case 'tare':
                        return returnLotWeightTare(lot, unit, invType);
                    case 'price':
                        return returnLotPrice(lot, invType);
                    case 'value':
                        return returnLotValue(lot, invType);
                }
            }
            return 0;
        }

        function returnLotPrice(lot, invType) {
            if (checkLot(lot)) {
                return isInvoicePurchase(invType) ? lot.purchPrice : lot.salePrice;
            }
        }

        function returnLotValue(lot, invType) {
            if (checkLot(lot)) {
                return isInvoicePurchase(invType) ? lot.purchValue : lot.saleValue;
            }
        }

        function returnLotWeightGross(lot, unit, invType) {
            var value = 0;
            if (checkLot(lot)) {
                switch (unit) {
                    case 'KG':
                        value = lot.purchLandedGrossKgs;
                        break;
                    case 'LB':
                        value = lot.purchLandedGrossLbs;
                        break;
                    case 'MT':
                        value = lot.purchLandedGrossMTs;
                        break;
                }
            }
            return value;
        }

        function returnLotWeightNet(lot, unit, invType) {
            if (checkLot(lot)) {
                switch (unit) {
                    case 'KG':
                        return lot.purchLandedNetKgs;
                    case 'LB':
                        return lot.purchLandedNetLbs;
                    case 'MT':
                        return lot.purchLandedNetMTs;
                }
            }
            return 0;
        }

        function returnLotWeightTare(lot, unit, invType) {
            if (checkLot(lot)) {
                switch (unit) {
                    case 'KG':
                        return lot.purchLandedTareKgs;
                    case 'LB':
                        return lot.purchLandedTareLbs;
                    case 'MT':
                        return lot.purchLandedTareMTs;
                }
            }
            return 0;
        }

        function checkLot(lot) {
            return lot !== undefined && lot !== null;
        }

        function checkDNDetails() {
            vm.showDNDetails = vm.invoice.invoiceCommissionRate !== undefined && vm.invoice.invoiceCommissionRate !== null;
        }

        function isInvoicePurchase(invType) {
            if (invType !== undefined && invType !== null) {
                return invType === "PURCHASE";
            } else {
                return false;
            }
        }

        function calculateTotalWeight() {
            return InvoiceDialogProvider.calculateTotalWeightOnDetails(vm);
        }

        function calculateTotalQty() {
            return InvoiceDialogProvider.calculateTotalQty(vm);
        }

        function calculateTotalMt() {
            return InvoiceDialogProvider.calculateTotalMt(vm);
        }

        function calculateTotalWeightLb() {
            return InvoiceDialogProvider.calculateTotalWeightLb(vm);
        }

        function calculateTotalWeightLbDetails() {
            return InvoiceDialogProvider.calculateTotalWeightLbDetails(vm);
        }

        function calculateTotalWeightDisplay() {
            return InvoiceDialogProvider.calculateTotalWeightDisplay(vm);
        }

        function calculateAvgPrice() {
            return InvoiceDialogProvider.calculateAvgPrice(vm);
        }

        function calculateTotalOverrideValue() {
            return InvoiceDialogProvider.calculateTotalOverrideValue(vm);
        }

        function calculateAvgNContractPrice() {
            return InvoiceDialogProvider.calculateAvgNContractPrice(vm);
        }

        function calculateTotalNContractValue() {
            return InvoiceDialogProvider.calculateTotalNContractValue(vm);
        }

        function calculateTotalOverrideValueDisplay() {
            return InvoiceDialogProvider.calculateTotalOverrideValueDisplay(vm);
        }

        function showNContract() {
            return vm.invoice.invoiceContractType === 'SALE'
                && (vm.invoice.invoiceContractCategory === 'TUI' || vm.invoice.invoiceContractCategory==='JAPAN')
                && ( vm.invoice.invoiceContractSubCategory === 'OUTSIDE' || vm.invoice.invoiceContractSubCategory === 'JAPAN' );
        }

        vm.getOrDash = function(val) {
            return (val && val !== null) ? val : '-';
        };

        vm.createTab = function (data) {
            $scope.$emit('handleEmit', data);
        };
    }
})();
